import React, { useEffect, useState, useMemo } from "react";
import { getCatrgoryInSurvay } from "../../api/helper";
import { useSelector } from "react-redux";

const MeasuresVitals = ({ onComplete }) => {
  const [categoriesState, setCategoriesState] = useState([]);
  const [currentQuestionnaire, setCurrentQuestionnaire] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [responses, setResponses] = useState([]);
  const profiledata = useSelector((state) => state?.cookies?.userDetails);

  const handleSave = () => {
    onComplete?.(true);
  };

  useEffect(() => {
    const getCategoryData = async () => {
      try {
        const response = await getCatrgoryInSurvay(
          `agencyId=${profiledata?._id}&preSet=true`
        );
        setCategoriesState(response.data.categories);
      } catch (error) {
        console.error("Failed to fetch categories:", error);
      }
    };
    getCategoryData();
  }, [profiledata?._id]);

  const questionnaireMap = useMemo(() => {
    const map = {};
    categoriesState.forEach((cat) => {
      if (cat.abbreviation) {
        map[cat.abbreviation.toLowerCase()] = cat;
      }
    });
    return map;
  }, [categoriesState]);

  const startQuestionnaire = (abbrev) => {
    const cat = questionnaireMap[abbrev.toLowerCase()];
    if (!cat) return;
    setCurrentQuestionnaire(abbrev.toLowerCase());
    setResponses(Array(cat.questions.length).fill(null));
    setCurrentIndex(0);
  };

  const handleAnswer = (idx) => {
    const updated = [...responses];
    updated[currentIndex] = idx;
    setResponses(updated);
  };

  const handleNext = () => {
    if (responses[currentIndex] === null) {
      alert("Please select an answer before proceeding.");
      return;
    }
    const q = questionnaireMap[currentQuestionnaire];
    if (currentIndex < q.questions.length - 1) {
      setCurrentIndex((i) => i + 1);
    } else {
      console.log(
        `Responses for ${q.abbreviation}:`,
        responses.map((i) => ({
          question: q.questions[responses.indexOf(i)],
          answer: q.answers[i].name,
        }))
      );
      alert(`${q.abbreviation} Completed! Check console for responses.`);
      setCurrentQuestionnaire(null);
    }
  };

  const handleBack = () => {
    if (currentIndex > 0) setCurrentIndex((i) => i - 1);
  };

  const handleRestart = () => {
    const q = questionnaireMap[currentQuestionnaire];
    setResponses(Array(q.questions.length).fill(null));
    setCurrentIndex(0);
  };

  return (
    <div className="basic-info-form">
      <h2>Measures Vitals Form</h2>
      <p className="form-description">
        Please complete required fields and questionnaires.
      </p>

      <form>
        <label htmlFor="height">Height (cm) *</label>
        <input type="number" id="height" required />
        <label htmlFor="weight">Weight (kg) *</label>
        <input type="number" id="weight" required />
        <label htmlFor="bloodPressure">Blood Pressure *</label>
        <input
          type="text"
          id="bloodPressure"
          placeholder="e.g., 120/80"
          required
        />
        <button
          className="cta-button"
          id="completeForm"
          type="button"
          style={{ marginTop: 20, width: "100%", marginBottom: 20 }}
          onClick={handleSave}
        >
          Save
        </button>
      </form>

      <hr />

      <h3 className="header_text_style">Questionnaires</h3>
      <div
        className="button-container"
        style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
      >
        {categoriesState.map((cat) => (
          <button
            key={cat?._id}
            className="cta-button"
            type="button"
            onClick={() => startQuestionnaire(cat.abbreviation)}
          >
            Take {cat.abbreviation} ({cat.name})
          </button>
        ))}
      </div>

      {currentQuestionnaire && (
        <div style={{ marginTop: 20 }}>
          {(() => {
            const q = questionnaireMap[currentQuestionnaire];
            const answerIdx = responses[currentIndex];
            return (
              <>
                <h4>
                  <strong>
                    {q.abbreviation} – Question {currentIndex + 1} of{" "}
                    {q.questions.length}
                  </strong>
                </h4>
                <p>{q.questions[currentIndex]}</p>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    marginTop: 10,
                  }}
                >
                  {q.answers.map((opt, idx) => (
                    <button
                      key={opt?._id}
                      className={`answer-btn ${answerIdx === idx ? "selected" : ""
                        }`}
                      onClick={() => handleAnswer(idx)}
                    >
                      {opt.name}
                    </button>
                  ))}
                </div>

                <div style={{ marginTop: 10, display: "flex", gap: "10px" }}>
                  <button
                    className="cta-button"
                    onClick={handleBack}
                    disabled={currentIndex === 0}
                  >
                    Back
                  </button>
                  <button className="cta-button" onClick={handleRestart}>
                    Restart
                  </button>
                  <button className="cta-button" onClick={handleNext}>
                    {currentIndex < q.questions.length - 1 ? "Next" : "Finish"}
                  </button>
                </div>
              </>
            );
          })()}
        </div>
      )}
    </div>
  );
};

export default MeasuresVitals;
